import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AuthLayout from './components/AuthLayout';
// Auth Pages
import AcceptInvitePage from './pages/AcceptInvitePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import LoginPage from './pages/LoginPage';
import LogoutPage from './pages/LogoutPage';
import MagicLinkPage from './pages/MagicLinkPage';
import MfaSetupPage from './pages/MfaSetupPage';
import MfaVerifyPage from './pages/MfaVerifyPage';
import PartnerOnboardingPage from './pages/PartnerOnboardingPage';
import RegisterPage from './pages/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

function OnboardRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/onboard${search}`} replace />;
}

export default function App() {
  return (
    <Routes>
      {/* Partner onboarding uses its own full-width layout (IntakeWizardScroll needs full viewport) */}
      <Route path="/onboard" element={<PartnerOnboardingPage />} />
      {/* Backwards compat for invite links that used the old /partner-onboarding path */}
      <Route path="/partner-onboarding" element={<OnboardRedirect />} />

      {/* Auth routes wrapped in AuthLayout (narrow card for login/register forms) */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/register/consumer" element={<RegisterPage isConsumer />} />
        <Route path="/magic-link" element={<MagicLinkPage />} />
        <Route path="/accept-invite" element={<AcceptInvitePage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/mfa/setup" element={<MfaSetupPage />} />
        <Route path="/mfa/verify" element={<MfaVerifyPage />} />
        <Route path="/logout" element={<LogoutPage />} />
      </Route>

      {/* Redirect root to login */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
